<template>
  <div class="Pagination">
      <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="pageSizes"
            :layout="type==1?'sizes, prev, pager, next, jumper, total':'prev, pager, next, jumper, total'"
            :total="total">
          </el-pagination>
  </div>
</template>

<script>
export default {
    props: {
        total:{
            type:Number
        },
        size:{
            type:Number
        },
        type:{
            type:String
        },
        pageSizes:{
            type:Array
        }
    },
    data(){
        return{
            currentPage:1,
            pagesize:this.size
        }
    },
    methods:{
        handleCurrentChange(e){
            this.currentPage = e
            this.$emit('handleCurrentChange',e)
        },
        handleSizeChange(e){
            this.$emit('handleSizeChange',e)
        }
    }
}
</script>

<style lang="scss">
.Pagination{
    width: 100%;
    z-index: 99;
    text-align: left;
    .el-pagination{
        // margin-top: 10px;
        padding-bottom: 10px;
        .el-pagination__sizes {
            .el-input {
                width: 7rem;
                .el-input__inner{
                    font-size: 0.75rem;
                }
            }
        }
        .btn-prev{
            background-color: rgba(0,0,0,0);
            color: #3E3A39;
            .el-icon-arrow-left:before{
                font-size: 0.75rem;
            }
        }
        .el-pager{
            .number {
                background-color: rgba(0,0,0,0);
                color:  #B5B5B6;
                font-size: 0.75rem;
                font-family: Arial;
                font-weight: 400;
            }
            .active{
                color: #3E3A39;
            }
            .el-icon-more{
                background-color: rgba(0,0,0,0);
                color:  #B5B5B6;
                font-size: 0.75rem;
                font-family: Arial;
                font-weight: 400;
            }
        }
        .btn-next{
            background-color: rgba(0,0,0,0);
            color: #3E3A39;
            .el-icon-arrow-right:before{
                font-size: 0.75rem;
            }
        }
        .el-pagination__jump{
            color: #B5B5B6;
            font-size: 0.75rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            .el-input{
                .el-input__inner{
                    font-size: 0.75rem;
                }
            }
        }
        .el-pagination__total{
            margin-left: 1rem;
            font-size: 0.75rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #3E3A39;
        }
    }
    .el-input__inner{
        background-color: rgba(0,0,0,0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Pagination.vue